// extracted by mini-css-extract-plugin
export default {"snetFooterContainer":"SnetFooter_snetFooterContainer__Y73hp","snetFooter":"SnetFooter_snetFooter__gXtcf"};